import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ViewAllEventsCalendarComponent} from './view-all-events-calendar.component';
import {CalendarHeaderComponent} from './utils/calendar-header.component';
import {CalendarModule, DateAdapter} from 'angular-calendar';
import {NgbPopoverModule} from '@ng-bootstrap/ng-bootstrap';
import {RouterModule} from '@angular/router';
import {ViewAllEventsCalendarRoutes} from './view-all-events-calendar.routes';
import {MatChipsModule} from '@angular/material/chips';
import {SharedModule} from '../../shared/shared.module';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {Daterangepicker} from 'ng2-daterangepicker';
import {adapterFactory} from 'angular-calendar/date-adapters/date-fns';
import { ShowPortfoliosDialogComponent } from './show-portfolios-dialog/show-portfolios-dialog.component';
import {MatListModule} from '@angular/material/list';

@NgModule({
  declarations: [
    ViewAllEventsCalendarComponent,
    CalendarHeaderComponent,
    ShowPortfoliosDialogComponent,
  ],
  imports: [
    SharedModule,
    CommonModule,
    // ---------------
    NgbPopoverModule,
    MatDatepickerModule,
    Daterangepicker,
    CalendarModule.forRoot({provide: DateAdapter, useFactory: adapterFactory}),
    RouterModule.forChild(ViewAllEventsCalendarRoutes),
    MatChipsModule,
    MatListModule,
  ],
  exports: [
    ViewAllEventsCalendarComponent,
    CalendarHeaderComponent,
  ]
})
export class ViewAllEventsCalendarModule { }
